import React from 'react';
import Tab from 'containers/Student/Subjects/Read/Tabs/Tab';

import { useStudentSubjectStore } from 'store/student/useStudentSubjectStore';

const Tabs = () => {
	// Use student's subject store
	const grades = useStudentSubjectStore(state => state.grades);

	return (
		<div className="mb-4 max-w-fit flex rounded-lg">
			{grades.map(grade =>
				<Tab key={grade.id} grade={grade} />
			)}
		</div>
	);
};

export default Tabs;